/*
 * @Descripttion: states
 * @Author: juanjuanhui
 * @Date: 2021-08-06 14:24:03
 * @LastEditors: quwandong
 * @LastEditTime: 2023-01-05 18:18:47
 */
const state = {
  userInfo: {},
  accessToken: "",
  isShowSideBar: true,
  headMenu: "",
  bdCurrentTab: "10", // 北斗终端当前tab
};
export default state;
